import { registerRemotes } from '@module-federation/enhanced/runtime';

const RUNTIME_REMOTES = [
  { name: 'shipbob_design_system', settingKey: 'SHIPBOB_DESIGN_SYSTEM', required: true },
  { name: 'shipbob_mfe_runtime', settingKey: 'SHIPBOB_MFE_RUNTIME', required: true },
];

/** Registers runtime remotes from app settings. */
export function registerRuntimeRemotes(appSettings) {
  const settings = appSettings || {};
  let hasAllRequiredRemotes = true;

  RUNTIME_REMOTES.forEach(({ name, settingKey, required }) => {
    const value = settings[settingKey];

    if (typeof value !== 'string' || !value.trim()) {
      if (required) {
        hasAllRequiredRemotes = false;
        console.error(`[reporting_ui] ${settingKey} missing or invalid in app settings`);
      }

      return;
    }

    const origin = value.trim().replace(/\/$/, '');
    registerRemotes([{ name, entry: `${origin}/remoteEntry.js` }], { force: true });
  });

  return hasAllRequiredRemotes;
}
